import React from "react";
import Logo from "../../assets/images/Logo/new-logo.png";
import { Box } from "@material-ui/core";
import { Stack, Button } from "@mui/material";

export const ErrorScreen = ({ text }) => {
  return (
    <Box
      sx={{
        height: "70vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Stack direction="column" alignItems="center" gap="16px">
        <img
          src={Logo}
          alt="logo"
          style={{
            width: "100px",
            height: "100px",
          }}
        />
        <p
          style={{
            fontWeight: 600
          }}
        >
          {text}
        </p>
      </Stack>
    </Box>
  );
};
